import { isVue2 } from "vue-demi";
import { abProvideKey } from "../constants.mjs";
const MyPlugin = {
  install(app, options) {
    if (options)
      if (isVue2) {
        app.mixin({
          beforeCreate() {
            if (!this._provided) {
              const provideCache = {};
              Object.defineProperty(this, "_provided", {
                get: () => provideCache,
                set: (v) => Object.assign(provideCache, v)
              });
            }
            this._provided[abProvideKey] = options;
          }
        });
      } else {
        app.provide(abProvideKey, options);
      }
    if (!options || !options.preset || options.preset === "asbis") {
      import("../assets/themes/asbis/theme.scss");
    }
  }
};
export default MyPlugin;
